import PropTypes from 'prop-types';

const SideBar = ({ color = undefined }) => (
  <div style={{ height: '100%', backgroundColor: color }} />
);

SideBar.propTypes = {
  color: PropTypes.string,
};

export default SideBar;
